<template>
  <div class="">
    <callout v-if="!state.success && !state.error" type="error" :closable="false">
      <div>
        <p class="-tight">
          Your email is not currently verified. Make sure your email address is correct and send a
          new verification email.
        </p>

        <button class="btn -dark -no-case" @click.prevent="resendEmail">
          Send verification email
        </button>
      </div>
    </callout>
    <callout v-if="state.success" type="success" @close-action="reset">
      <div>{{ state.success }}</div>
    </callout>
    <callout v-if="state.error" type="error" @close-action="reset">
      <div>{{ state.error }}</div>
    </callout>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { fbApi, FbApiError } from '@/utils/http-api'
import Callout from '@/components/notifications/callout.vue'

/** PROPS **/
// none

/** STATE **/
const state = ref({
  processing: false,
  success: '',
  error: '',
})

/** COMPUTED **/

/** METHODS **/
function reset() {
  state.value = {
    processing: false,
    success: '',
    error: '',
  }
}
async function resendEmail() {
  // no double submit
  if (state.value.processing) {
    return
  }

  // validation
  state.value.processing = true

  try {
    await fbApi.post(`/my/verify/email`, {
      skipErrorModal: true,
    })

    state.value.success = 'Email sent, please check your inbox'
  } catch (err) {
    // generic error
    state.value.error = 'Error sending email, please refresh the page and try again'

    // already verified message
    if (err && err instanceof FbApiError && err.status === 400 && err.body?.message) {
      state.value.error = err.body.message
    }
  } finally {
    state.value.processing = false
  }
}
</script>
